import React from 'react';
import { connect } from 'react-redux';
import SearchBarDropDown from 'components/common/searchbardropdown';
import { putNode } from 'actions/comparison';
import Widgets from 'components/pages/comparison/comparisoncard/widgets';
import ComparisonStats from 'components/pages/comparison/comparisoncard/comparisonstats';
export class ComparisonCard extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            value: [{ label: undefined }, { label: undefined }]
        }
    }

    componentDidMount() {
        // Default location
        var nextProps = this.props;
        if (nextProps.tree.id > 0) {
            if (nextProps.tree.children) {
                if (nextProps.tree.type == 'customer') {
                    this.chooseFirstLocation(nextProps.tree.children[0]);
                    this.chooseSecondLocation(nextProps.tree.children[0]);
                } else {
                    this.chooseFirstLocation(nextProps.tree);
                    this.chooseSecondLocation(nextProps.tree);
                }
            }
        }
    }

    chooseFirstLocation(node) {
        if (node.id) {
            this.updateInput(0, node);
            this.props.dispatch(putNode(node, 0));
        }

    }

    chooseSecondLocation(node) {
        if (node.id) {
            this.updateInput(1, node);
            this.props.dispatch(putNode(node, 1));
        }
    }

    updateInput(id, node) {
        var value = this.state.value.slice();
        value[id].label = node.info.name;
        this.setState({
            value: value
        });
    }

    resetInput(id) {
        var value = this.state.value.slice();
        value[id].label = undefined;
        this.setState({
            value: value
        });
    }

    render() {
        return (
            <div className="comparison-grid-widget">
                <div className="grid-widget__first-location">
                    <div className="comparison__search-container">
                        <SearchBarDropDown
                            onChange={(node) => { this.chooseFirstLocation(node) }}
                            onFocus={() => { this.resetInput(0) }}
                            onOpen={() => { this.resetInput(0) }}
                            onClose={() => { }}
                            value={this.state.value[0]}
                            tree={this.props.tree}
                        />
                    </div>
                </div>
                <div className="grid-widget__second-location">
                    <div className="comparison__search-container">
                        <SearchBarDropDown
                            onChange={(node) => { this.chooseSecondLocation(node) }}
                            onFocus={() => { this.resetInput(1) }}
                            onOpen={() => { this.resetInput(1) }}
                            onClose={() => { }}
                            value={this.state.value[1]}
                            tree={this.props.tree}
                        />
                    </div>
                </div>
                <Widgets querySettings={this.props.querySettings} allSensors={this.props.allSensors} />
                <div className="grid-widget-card">
                    <ComparisonStats />
                </div>
            </div>


        );
    }
}

function mapStateToProps(state) {
    return {
        tree: state.overviewReducer.customerOverview,
        querySettings: state.querySettingsReducer,
        allSensors: state.nodeReducer.map
    };
}
function mapDispatchToProps(dispatch) {
    return {
        dispatch
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ComparisonCard);




// WEBPACK FOOTER //
// ./src/components/pages/comparison/comparisoncard/index.jsx